export default __webpack_public_path__ + "static/media/vc-condition-create-voice.f56880ea.png";